import React from 'react'
import { styled, FloraVariants, forwardRef } from '@grupoboticario/flora-react-system'
import { HTMLFloraProps } from '@grupoboticario/flora-react-utils'

const StyledTableCellIcon = styled('picture', {
  size: '$8',
  display: 'inline-block',
  borderRadius: '$small',
  padding: '$2',
  backgroundColor: '$backgroundSecondary',
  '> *': {
    size: '$4',
  },
  svg: {
    borderTopLeftRadius: '$medium',
    borderBottomLeftRadius: '$medium',
    size: '$4',
  },
})

export type TableCellIconProps = HTMLFloraProps<'picture'> &
  FloraVariants<typeof StyledTableCellIcon>

export const TableCellIcon = forwardRef<'picture', TableCellIconProps>((props, forwardedRef) => {
  return <StyledTableCellIcon ref={forwardedRef} data-flora="table-cell-icon" {...props} />
})
